<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" :model="searchForm" :ref="searchForm" center>
          <el-form-item label="供应商：">
            <el-select filterable v-model="searchForm.SUPPLIER_LIST" placeholder="请选择" clearable multiple collapse-tags>
              <el-option v-for="item in supplier" :key="item.value" :label="item.NAME" :value="item.SUPPLIER_ID">
                <span style="float: left">{{ item.NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.PRODUCT_CODE" clearable></el-input>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-button size="medium" type="primary" @click="handleSearch()">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin:15px 0">
      <el-button size="medium" @click="exportData()">导出</el-button>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="TOTAL_COUNT" label="采购总量"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="含税采购总金额"></el-table-column>
          <el-table-column prop="TOTAL_BEFORE_TAX_FEE" label="不含税采购总金额"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="height: 100px">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalNum" style="float: right; height: 100px">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import { haveGYSFun } from 'api/shopOrderManage';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      supplier: [
        {
          NAME: '',
          SUPPLIER_ID: '',
        },
      ],
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
    };
  },
  created() {
    this.querySupplier();
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // 获取供应商信息列表
    querySupplier() {
      const params = {};
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_NAME = this.searchForm.SUPPLIER;
      }
      haveGYSFun().then((result) => {
        this.supplier = result.length > 0 ? this.$util.listRemoveDuplicates(result[0].list) : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportData() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 92,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return;
      }
      if (this.searchForm.SUPPLIER_LIST && this.searchForm.SUPPLIER_LIST.length > 0) {
        params.SUPPLIER_LIST = this.searchForm.SUPPLIER_LIST;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      http.post(params).then((result) => {
        if (result.length === 0) {
          this.$message.show({ text: '未查询到相关导出数据', type: 'warning' });
          return;
        }
        window.location.href = this.$util.getURLLocalHost(result.FILE_PATH);
        this.$message.show({ text: '导出成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryData() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 93,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return;
      }
      if (this.searchForm.SUPPLIER_LIST && this.searchForm.SUPPLIER_LIST.length > 0) {
        params.SUPPLIER_LIST = this.searchForm.SUPPLIER_LIST;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      http.post(params).then((result) => {
        if (result.DATA_LIST && result.DATA_LIST.length > 0) {
          this.tableData = result.DATA_LIST;
          this.totalNum = result.TOTAL_COUNT;
        } else {
          this.$message.show({ text: '未查询到相关数据', type: 'warning' });
          this.tableData = [];
          this.totalNum = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/supplierSingleItemProcurementSummary.vue